export const NAVBAR_TABS = {
  ANNOUNCEMENTS: "Annoucements",
  OPINIONS: "Opninions",
  FEEDBACKS: "Feedbacks",
};
